import { Pipe, PipeTransform } from '@angular/core';
import { Beneficiario } from '../entities/personajes';

@Pipe({
  name: 'relacionados'
})
export class BeneficiariosRelacionadosPipe implements PipeTransform {

  transform(value: Array<Beneficiario>, args: string): Array<Beneficiario> {
    console.log(value,args);
    if(args === "" || args === undefined || args === null) return value;
    return value.filter(beneficiario=>beneficiario.titular == args);
  }

}
